<template>
  <div
    name="rb-tab"
    :style="cssVars"
    :class="{ [`${customClass}`]: customClass }"
  >
    <div class="tab-header">
      <a
        v-for="( item, index ) in header"
        :key="index"
        :class="{ active: item === active, primary, secondary }"
        @click="change(item)"
      >{{ item
      }}</a>
    </div>
    <hr>
    <div class="tab-body">
      <slot />
    </div>
    <div class="tab-bottom">
      <slot name="bottom" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, onBeforeMount, onMounted, ref } from 'vue';
import { getRootElement } from '@/lib/Utils';

const props = defineProps<{
  header: Array<string>,
  primary?: boolean,
  secondary?: boolean
}>();

const active = ref('');
const customClass = ref('');
const bottom = ref(0);

onBeforeMount(() => {
  customClass.value = 'rbnav-' + Math.floor(Math.random() * 100);
  change(props.header[0]);
});

onMounted(() => {
  bottom.value = getRootElement().querySelector(`.${customClass.value} .tab-bottom`)?.offsetHeight ?? 0;
});

function change(item: string) {
  active.value = item;
}

const cssVars = computed(() => {
  return {
    ['--height-bottom']: bottom.value + 'px',
    ['--height-top']: '43px'
  };
});
</script>

<style lang="scss" scoped>
div[name="rb-tab"] {
  display: flex;
  flex-direction: column;

  .tab-header {
    display: flex;
    height: var(--height-top);
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;

    &>a {
      box-sizing: border-box;
      height: 100%;
      flex: 1;
      min-width: min-content;
      font-weight: 400;
      font-size: 0.95rem;
      line-height: 43px;
      text-align: center;
      color: var(--text);
      cursor: pointer;
      border-bottom: 2px solid transparent;
      text-wrap: nowrap;
      padding: 0 12px;

      &.active {
        border-bottom: 4px solid var(--border);
        color: rgba(0, 0, 0, 0.87);

        &.primary {
          border-bottom: 4px solid var(--primary);
        }

        &.secondary {
          border-bottom: 4px solid var(--secondary);
        }
      }
    }
  }

  hr {
    width: 100%;
    border-color: rgba(212, 212, 212, 0.3);
    padding: 0;
    margin: 0;
  }

  .tab-body {
    overflow-y: auto;
    max-height: calc(85vh - var(--height-top) - var(--height-bottom));
  }
}
</style>
